import { useEffect, useState } from "react";
import { QUALIFICATION_STATUS } from "../../../common/enums/incentive-enums";
import {
  legsTrackingAPI,
  useGetLegsTrackingQuery,
} from "../../../services/HigherAwardTracking/LegsTracking/legsTrackingAPI";
import { lambdaErrorCheck } from "../../../common/util/errorHandling";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { LegsTrackingAPIResponse } from "../../../services/HigherAwardTracking/HigherAwardTrackingAPI.types";

export const defaultLegsTrackingData = (): LegsTrackingAPIResponse => {
  return {
    SelectedPYTotals: {
      PerformanceYear: 0,
      InMarketTotal: 0,
      InternationalTotal: 0,
      FoundersLegs: 0,
      TotalQLegs: 0,
    },
    PreviousPYTotals: {
      PerformanceYear: 0,
      InMarketTotal: 0,
      InternationalTotal: 0,
      FoundersLegs: 0,
      TotalQLegs: 0,
    },
    InMarketQLegs: {
      SelectedPYMonthlyTotals: [],
      PreviousPYMonthlyTotals: [],
      Legs: [],
    },
    InternationalQLegs: {
      SelectedPYMonthlyTotals: [],
      PreviousPYMonthlyTotals: [],
      Legs: [],
    },
    InMarketNonQLegsAbove9Percent: {
      SelectedPYMonthlyTotals: [],
      PreviousPYMonthlyTotals: [],
      Legs: [],
    },
    CurrentProcessingPeriod: 0,
    DisplayRequirementTiles: false,
    ShowDateRangeError: false,
    CallResults: [],
    Error: [],
    statusCode: 0,
  };
};

export const FetchLegsTrackingData = (period: string) => {
  const { user } = useAppSelector((state) => state.boot);
  const locale = storedLocale();
  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetLegsTrackingQuery({
    abo: user.abo,
    aff: user.aff,
    period: period,
    locale: locale,
    inMarketOnly: "false",
    useGarAuth: "false",
    isoCountryCode: user.isoCountryCode,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [legsTrackingData, setLegsTrackingData] = useState<LegsTrackingAPIResponse>(defaultLegsTrackingData());

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setLegsTrackingData(payloadData);
      const foundLambdaError = lambdaErrorCheck(payloadData.Error);
      setErrorStatus(foundLambdaError);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, legsTrackingData, errorStatus, refetch };
};
